import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\StoreCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/StoreCommissionNoteController.php
* @route '/api/commission-note'
*/
const StoreCommissionNoteController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCommissionNoteController.url(options),
    method: 'post',
})

StoreCommissionNoteController.definition = {
    methods: ["post"],
    url: '/api/commission-note',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\StoreCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/StoreCommissionNoteController.php
* @route '/api/commission-note'
*/
StoreCommissionNoteController.url = (options?: RouteQueryOptions) => {
    return StoreCommissionNoteController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\StoreCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/StoreCommissionNoteController.php
* @route '/api/commission-note'
*/
StoreCommissionNoteController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCommissionNoteController.url(options),
    method: 'post',
})

export default StoreCommissionNoteController